<template>
  <date-range-picker
    ref="picker"
    :opens="direction"
    :minDate="minDate"
    :maxDate="maxDate"
    :showWeekNumbers="true"
    :showDropdowns="true"
    :autoApply="true"
    :timePicker="false"
    :timePicker24Hour="false"
    :ranges="ranges"
    v-model="dateRange"
    @update="updateDateRange"
    @select="updateDateRange"
    :dateRange="dateRange">
    <template #input="{ startDate, endDate }">
      <div class="flex justify-center md:space-x-3" v-if="startDate">
        <CalendarIcon class="w-5" />
        <div class="hidden md:block">{{ startDate.toLocaleDateString() }}</div>
        <div class="hidden md:block">&rarr;</div>
        <div class="hidden md:block">{{ endDate.toLocaleDateString() }}</div>
      </div>
    </template>
  </date-range-picker>
</template>

<script setup>
import DateRangePicker from 'vue3-daterange-picker'
import { DateTime } from 'luxon'
import { CalendarDaysIcon as CalendarIcon } from '@heroicons/vue/24/outline'
import { changeDateToStartAtMidnight } from '@/services/date'

const props = defineProps({
  modelValue: Object,
  earliestDate: String,
  latestDate: String,
  direction: { type: String, default: 'left' }
})
const emit = defineEmits(['update:modelValue'])

const minDate = DateTime.fromISO(props.earliestDate).toISO()
const maxDate = DateTime.now().toISO()
const dealWithSameDate = (range) => {
  const startDate = range.startDate.toISOString()
  const endDate = range.endDate.toISOString()
  if (startDate !== endDate) return { startDate, endDate }
  const [startDatePart, startTimePart] = startDate.split('T')
  const newStartISOString = `${startDatePart}T00:00:00.000Z`
  const [endDatePart, endTimePart] = endDate.split('T')
  const newEndISOString = `${endDatePart}T23:59:00.000Z`
  return { startDate: newStartISOString, endDate: newEndISOString }
}
const dateRange = ref({
  startDate: props.modelValue.start,
  endDate: props.modelValue.end
})

const updateDateRange = (range) => {
  const newRange = dealWithSameDate(range)
  dateRange.value = newRange
  console.log('newRange', newRange)
  emit('update:modelValue', {
    start: changeDateToStartAtMidnight(newRange.startDate),
    end: new Date(newRange.endDate)
  })
}

const ranges = {
  Today: [
    DateTime.now().startOf('day').toJSDate(),
    DateTime.now().endOf('day').toJSDate()
  ],
  'Last 7 Days': [
    DateTime.now().minus({ days: 6 }).startOf('day').toJSDate(),
    DateTime.now().endOf('day').toJSDate()
  ],
  'Last 14 Days': [
    DateTime.now().minus({ days: 13 }).startOf('day').toJSDate(),
    DateTime.now().endOf('day').toJSDate()
  ],
  'Last 30 Days': [
    DateTime.now().minus({ days: 29 }).startOf('day').toJSDate(),
    DateTime.now().endOf('day').toJSDate()
  ],
  'This Month': [
    DateTime.now().startOf('month').toJSDate(),
    DateTime.now().endOf('month').toJSDate()
  ],
  'Last Month': [
    DateTime.now().minus({ months: 1 }).startOf('month').toJSDate(),
    DateTime.now().minus({ months: 1 }).endOf('month').toJSDate()
  ],
  'Last 90 Days': [
    DateTime.now().minus({ days: 89 }).startOf('day').toJSDate(),
    DateTime.now().endOf('day').toJSDate()
  ]
  // 'Last 365 Days': [
  //   DateTime.now().minus({ days: 364 }).startOf('day').toJSDate(),
  //   DateTime.now().endOf('day').toJSDate()
  // ],
  // 'This Year': [
  //   DateTime.now().startOf('year').toJSDate(),
  //   DateTime.now().endOf('year').toJSDate()
  // ],
  // 'Last Year': [
  //   DateTime.now().minus({ years: 1 }).startOf('year').toJSDate(),
  //   DateTime.now().minus({ years: 1 }).endOf('year').toJSDate()
  // ]
}
</script>

<!-- <script>
// NB this can easily be changed into a AppDatePicker later (i.e. support for both ranges & single dates) using the `daterange--single` feature

import moment from 'moment'
import Calendar from 'baremetrics-calendar'
import DateRangePicker from 'vue3-daterange-picker'

export default {
  props: {
    value: {
      type: Object,
      validator(value) {
        return value.hasOwnProperty('start') && value.hasOwnProperty('end')
      },
      default() {
        return {
          start: moment().subtract(6, 'days'),
          end: moment()
        }
      }
    },

    earliestDate: {
      type: String, // moment parseable
      default: '2018-01-01'
    },

    latestDate: {
      type: String, // moment parseable
      default: undefined
    }
  },
  components: { DateRangePicker },
  data() {
    return {
      calendar: null,
      dateRange: {
        startDate: null,
        endDate: null
      },
      ranges: {
        Today: [moment(), moment()],
        'Last 7 Days': [moment().subtract(6, 'days'), moment()],
        'Last 14 Days': [moment().subtract(13, 'days'), moment()],
        'Last 30 Days': [moment().subtract(29, 'days'), moment()],
        'This Month': [moment().startOf('month'), moment().endOf('month')],
        'Last Month': [
          moment().subtract(1, 'month').startOf('month'),
          moment().subtract(1, 'month').endOf('month')
        ]
        // Today: [moment(), moment()]
        // Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        // 'Last 7 Days': [moment().subtract(6, 'days'), moment()],
        // 'Last 30 Days': [moment().subtract(29, 'days'), moment()],
        // 'This Month': [moment().startOf('month'), moment().endOf('month')],
        // 'Last Month': [
        //   moment().subtract(1, 'month').startOf('month'),
        //   moment().subtract(1, 'month').endOf('month')
        // ]
      }
    }
  },

  watch: {
    // No point in this: baremetrics-calendar doesn't currently support changing dates from the outside AFAICT.
    //            value(v) {
    //                if (this.calendar) {
    //                    this.calendar.start_date = moment(v.start);
    //                    this.calendar.end_date = moment(v.end);
    //                }
    //            },
  },

  mounted() {
    this.dateRange = {
      startDate: this.value.start,
      endDate: this.value.end
    }
    // const vm = this;

    // vm.calendar = new Calendar({
    //     element: $(this.$refs.picker),
    //     earliest_date: moment(vm.earliestDate).startOf('day'),
    //     latest_date: moment(vm.latestDate).endOf('day'),
    //     start_date: moment(vm.value.start),
    //     end_date: moment(vm.value.end),
    //     same_day_range: true,
    //     presets: [
    //         {
    //             label: 'Today',
    //             start: moment(),
    //             end: moment(),
    //         },
    //         {
    //             label: '7 days',
    //             start: moment().subtract(6, 'days'),
    //             end: moment(),
    //         },
    //         {
    //             label: '30 days',
    //             start: moment().subtract(29, 'days'),
    //             end: moment(),
    //         },
    //         {
    //             label: 'Last month',
    //             start: moment().subtract(1, 'month').startOf('month'),
    //             end: moment().subtract(1, 'month').endOf('month')
    //         },
    //         {
    //             label: 'Last 3 months',
    //             start: moment().subtract(3, 'month').startOf('month'),
    //             end: moment().subtract(1, 'month').endOf('month')
    //         },
    //         {
    //             label: 'Last 6 months',
    //             start: moment().subtract(6, 'month').startOf('month'),
    //             end: moment().subtract(1, 'month').endOf('month')
    //         },
    //         {
    //             label: 'Last year',
    //             start: moment().subtract(1, 'year').startOf('year'),
    //             end: moment().subtract(1, 'year').endOf('year')
    //         },
    //     ],
    //     callback: function() {
    //         vm.picked(this.start_date, this.end_date);
    //     }
    // });
  },

  methods: {
    picked(start, end) {
      this.$emit('input', {
        start: moment(start).startOf('day').toISOString(),
        end: moment(end).endOf('day').toISOString()
      })
    },
    dateFormat(classes, date) {
      //What to do here
      return classes
    }
  }
}
</script> -->

<style lang=""></style>
